export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.10-0815.24",
  commitId: "7e156033e173e2a68a20e408895a347a7a680ff6",
  commitTime: "2026-07-10T08:15:24.000Z",
});
